var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeleteBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-delete"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    clipPath: "url(#clip-delete)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2538",
    "data-name": "Rectangle 2538",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869",
    transform: "translate(-509 -224.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2445",
    "data-name": "Rectangle 2445",
    transform: "translate(516 230)",
    fill: "none",
    stroke: "#367ef3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H10a0,0,0,0,1,0,0V11a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h9a0,0,0,0,1,0,0V11A1.5,1.5,0,0,1,8,12.5H2A1.5,1.5,0,0,1,.5,11V.5A0,0,0,0,1,.5.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11013",
    "data-name": "Path 11013",
    d: "M-3152.222-485.644v6",
    transform: "translate(3671.722 719.144)",
    fill: "none",
    stroke: "#367ef3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11014",
    "data-name": "Path 11014",
    d: "M-3152.222-485.644v6",
    transform: "translate(3674.722 719.144)",
    fill: "none",
    stroke: "#367ef3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11015",
    "data-name": "Path 11015",
    d: "M-3152.222-485.644v4.3",
    transform: "translate(37.504 3381.722) rotate(90)",
    fill: "none",
    stroke: "#367ef3",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11016",
    "data-name": "Path 11016",
    d: "M-3152.222-485.644v12.23",
    transform: "translate(41.47 3382.722) rotate(90)",
    fill: "none",
    stroke: "#367ef3",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteBlue);
export default __webpack_public_path__ + "static/media/icon_delete_blue.9f804134e2471728d7190a43629e910d.svg";
export { ForwardRef as ReactComponent };